// @flow
/**
 * User: Mike Chung
 * Date: 21/1/2018
 * Time: 12:30 AM
 */
import {connect} from "react-redux";
import type {StoreState} from "../../reducers/combinedReducers";
import type {
    EBadgeActionButtonDispatchProps,
    EBadgeActionButtonOwnProps,
    EBadgeActionButtonStateProps
} from "../../components/ebadge/EBadgeActionButton";
import EBadgeActionButton from "../../components/ebadge/EBadgeActionButton";
import {openLockEBadgeModalAction} from "../../actions/ebadge/creators/eBadgeLockActionCreator";
import {extractCaller} from "../QueryPage";
import type {Caller} from "../../components/QueryPage";

function getIsLoadingStatus(state, registrationCode) {
    let eBadgeUnlockStatus = state.eBadgeAction.lock[registrationCode];
    if (eBadgeUnlockStatus) {
        return eBadgeUnlockStatus.isLoading;
    } else {
        return false;
    }
}

const mapStateToProps = (state: StoreState, ownProps: EBadgeActionButtonOwnProps): EBadgeActionButtonStateProps => {
    const registrationCode = ownProps.registrationCode;
    const isLoading = getIsLoadingStatus(state, registrationCode);
    return {
        isLoading,
        caller: extractCaller(state),
        roleIds: state.loginUser.roleIds
    };
};

const mapDispatchToProps = (dispatch): EBadgeActionButtonDispatchProps => {
    return {
        onClick: (registrationCode: string, unlockCount: number, caller: Caller, roleIds: Array<string>) => {

            dispatch(openLockEBadgeModalAction(registrationCode));
        }
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(EBadgeActionButton);



// WEBPACK FOOTER //
// ./src/containers/ebadge/LockEBadgeButton.js